var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height",class:_vm.isDark ? 'theme--dark v-sheet' : 'white'},[_c('Toolbar',{attrs:{"toolbarTitle":_vm.$t('Archivmanager'),"tooltipMessage":"Hier können Sie Kataloge im Archiv von User bearbeiten."}}),_c('ArchiveTool')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }